export enum GoalsPermissions {
  Read = 'SMART_GOALS:GOAL:READ',
  Create = 'SMART_GOALS:GOAL:CREATE',
  Update = 'SMART_GOALS:GOAL:UPDATE',
}

export type SmartGoalsPermissions = GoalsPermissions;
